import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { components, LineAutoMessageLogType } from '@/schema'
import LineMessageLogTable from '../LineMessageLogTable'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'

type LineAutoMessageLogModel =
	components['schemas']['AdminLineAutoMessageLogModel']

interface LineMessageLogListingProps {
	data: LineAutoMessageLogModel[]
	total: number
	isLoading?: boolean
	logTypeFilter: LineAutoMessageLogType | ''
	onLogTypeChange: (value: LineAutoMessageLogType | '') => void
}

export default function LineMessageLogListing({
	data,
	total,
	isLoading,
	logTypeFilter,
	onLogTypeChange,
}: LineMessageLogListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
				<Heading
					title="LINE Message Log"
					description="ประวัติการส่งข้อความ LINE อัตโนมัติ"
				/>
				<div className="flex flex-col gap-2 sm:items-end">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>
			<Separator />
			<LineMessageLogTable
				data={data}
				total={total}
				isLoading={isLoading}
				logTypeFilter={logTypeFilter}
				onLogTypeChange={onLogTypeChange}
			/>
		</div>
	)
}
